import React, { Fragment, useState } from 'react';
import { Card, Button } from 'reactstrap';
import moment from 'moment';
import parse from 'html-react-parser'; import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import EventsForm from './GuestsPassForm';
export default function GuestsPassHistoryList({
  item,
  lang,
  handleUpdate,
  propertyId,
}) {
  const [isUpdating, setIsUpdating] = useState(false);
  return (
    <Fragment>
      <Colxx xxs="12">
        <Card className="d-flex flex-row mb-3">
          <div className="pl-2 d-flex flex-grow-1 min-width-zero col-12">
            <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
              <p className="mb-1 text-small w-20 w-sm-100">
                <b>{item.location}</b>
              </p>
              <p className="mb-1 text-small w-20 w-sm-100">
                <b>{item.visitor}</b>
              </p>
              <p className="mb-1 text-small w-20 w-sm-100">{item.guests}</p>
              <p className="mb-1 text-small w-15 w-sm-100">
                <b>{moment(item.bookingDate).format('MMMM Do, YYYY')}</b>
              </p>
              <p className="mb-1 text-muted text-small w-10 w-sm-100">
                {item.status === 'Used' ? (
                  moment(item.bookingDate).format('MMMM Do, YYYY') ===
                    moment().format('MMMM Do, YYYY') ? (
                    <span
                      className="mb-3"
                      style={{
                        color: `green`,
                      }}
                    >
                      Valid Today
                    </span>
                  ) : (
                    <span
                      className="mt-n2"
                      style={{
                        color: `red`,
                      }}
                    >
                      {item.status}
                    </span>
                  )
                ) : (
                  <span
                    className="mb-3"
                    style={{
                      color: `${item.status === 'Used' ? 'red' : 'green'}`,
                    }}
                  >
                    {' '}
                    {item.status}
                  </span>
                )}
              </p>
              {item.status !== 'Used' && (
                <div className="w-sm-100">
                  <Button
                    color="primary"
                    size="xs"
                    outline
                    onClick={() => handleUpdate(item?.id)}
                  >
                    Mark as used
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Card>
      </Colxx>
    </Fragment>
  );
}
